module.exports = __webpack_public_path__ + "static/img/design-hddicon.1ec81d6.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/works/design-hddicon.jpg
 ** module id = 14
 ** module chunks = 1
 **/